module.exports = __webpack_public_path__ + "img/research_9.34e1cb6d.png";